import { render, staticRenderFns } from "./usergroup-renderer.vue?vue&type=template&id=fc11bb78&"
import script from "./usergroup-renderer.vue?vue&type=script&lang=js&"
export * from "./usergroup-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports